import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { DEMO_PROFILES } from '../data/demo';
import Avatar from '../components/ui/Avatar';
import Button from '../components/ui/Button';
import GlassCard from '../components/ui/GlassCard';
import { FiArrowLeft, FiCamera, FiStar, FiHeart, FiMapPin, FiEdit3, FiShield, FiChevronRight, FiLogOut } from 'react-icons/fi';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('about');
  const profile = user || DEMO_PROFILES[0];
  const completion = user ? (user.photos?.length > 0 ? 80 : 40) : 65;

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 90 }}>
      {/* Header */}
      <div style={{
        position: 'relative', height: 320, overflow: 'hidden',
      }}>
        {profile.photos?.[0] ? (
          <img src={profile.photos[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${profile.name}&background=1A1A24&color=FF3D71&size=800`; }} />
        ) : (
          <img src={`https://ui-avatars.com/api/?name=${profile.name || 'User'}&background=1A1A24&color=FF3D71&size=800`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(transparent 40%, #08080C)' }} />
        <button onClick={() => navigate('/settings')} style={{
          position: 'absolute', top: 16, right: 16,
          width: 40, height: 40, borderRadius: 12, background: 'rgba(0,0,0,0.4)',
          backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.1)',
          color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}><FiEdit3 size={16} /></button>
      </div>

      <div style={{ padding: '0 20px', marginTop: -40, position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 16, marginBottom: 16 }}>
          <Avatar src={profile.photos?.[0]} name={profile.name} size={80} ring verified={profile.isVerified} />
          <div style={{ flex: 1, paddingBottom: 4 }}>
            <h2 style={{ fontSize: 24, fontWeight: 800 }}>
              {profile.name || user?.name || 'User'}, {profile.age || 24}
            </h2>
            <p style={{ fontSize: 14, color: '#A1A1AA', display: 'flex', alignItems: 'center', gap: 4 }}>
              <FiMapPin size={13} /> {profile.city || user?.city || 'Location'}
            </p>
          </div>
        </div>

        {/* Completion */}
        <div style={{
          padding: '14px 16px', borderRadius: 16, marginBottom: 20,
          background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: '#A1A1AA' }}>Profile completion</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#FF3D71' }}>{completion}%</span>
          </div>
          <div style={{ height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.06)' }}>
            <div style={{ height: '100%', borderRadius: 2, width: `${completion}%`, background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)' }} />
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: 0, marginBottom: 20, background: 'rgba(255,255,255,0.03)', borderRadius: 12, padding: 3 }}>
          {['about', 'photos', 'prompts'].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)} style={{
              flex: 1, padding: '10px', borderRadius: 10, border: 'none',
              background: activeTab === tab ? 'rgba(255,255,255,0.08)' : 'transparent',
              color: activeTab === tab ? '#FFFFFF' : '#71717A',
              fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter',
              textTransform: 'capitalize', transition: 'all 0.2s',
            }}>{tab}</button>
          ))}
        </div>

        {activeTab === 'about' && (
          <div>
            <p style={{ fontSize: 15, color: '#D4D4D8', lineHeight: 1.6, marginBottom: 20 }}>
              {profile.bio || 'Coffee enthusiast | Weekend traveler | Dog mom 🐕'}
            </p>
            <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Interests</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 24 }}>
              {(profile.interests || ['Music', 'Travel', 'Coffee']).map(i => (
                <span key={i} style={{ padding: '6px 14px', borderRadius: 10, background: 'rgba(255,61,113,0.08)', color: '#FF3D71', fontSize: 13, fontWeight: 500 }}>{i}</span>
              ))}
            </div>

            {/* Menu items */}
            {[
              { icon: <FiStar size={18} />, label: 'Premium', desc: 'Unlock all features', path: '/premium', color: '#F59E0B' },
              { icon: <FiShield size={18} />, label: 'Safety Center', desc: 'Verification & safety tips', path: '/safety', color: '#22C55E' },
              { icon: <FiHeart size={18} />, label: 'Relationship Goals', desc: 'Serious Relationship', color: '#FF3D71' },
            ].map((item, i) => (
              <button key={i} onClick={() => item.path && navigate(item.path)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 14, width: '100%',
                  padding: '14px 0', background: 'none', border: 'none',
                  cursor: 'pointer', fontFamily: 'Inter', textAlign: 'left',
                  borderBottom: '1px solid rgba(255,255,255,0.04)',
                }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: `${item.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.color }}>
                  {item.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <h4 style={{ fontSize: 14, fontWeight: 500, color: '#FFFFFF' }}>{item.label}</h4>
                  <p style={{ fontSize: 12, color: '#71717A' }}>{item.desc}</p>
                </div>
                <FiChevronRight size={16} style={{ color: '#52525B' }} />
              </button>
            ))}

            <button onClick={handleLogout} style={{
              display: 'flex', alignItems: 'center', gap: 14, width: '100%',
              padding: '16px 0', marginTop: 12, background: 'none', border: 'none',
              cursor: 'pointer', fontFamily: 'Inter', color: '#EF4444',
              fontSize: 14, fontWeight: 500,
            }}><FiLogOut size={18} /> Logout</button>
          </div>
        )}

        {activeTab === 'photos' && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
            {(profile.photos || []).map((p, i) => (
              <div key={i} style={{ aspectRatio: 3/4, borderRadius: 12, overflow: 'hidden' }}>
                <img src={p.startsWith('http') ? p : `https://rt.vitaldew.in${p}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${profile.name}&background=1A1A24&color=FF3D71&size=400`; }} />
              </div>
            ))}
            {(!profile.photos || profile.photos.length < 6) && (
              <button style={{
                aspectRatio: 3/4, borderRadius: 12, border: '2px dashed rgba(255,255,255,0.08)',
                background: 'rgba(255,255,255,0.02)', color: '#71717A', cursor: 'pointer',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 6,
              }}><FiCamera size={20} /><span style={{ fontSize: 11 }}>Add</span></button>
            )}
          </div>
        )}

        {activeTab === 'prompts' && (
          <div style={{ padding: '16px', borderRadius: 16, background: 'rgba(255,61,113,0.06)', border: '1px solid rgba(255,61,113,0.12)' }}>
            <p style={{ fontSize: 13, color: '#FF3D71', fontWeight: 600, marginBottom: 6 }}>My perfect Sunday is...</p>
            <p style={{ fontSize: 14, color: '#D4D4D8', lineHeight: 1.5 }}>Exploring a new cafe, long drive, and sunset photography 📸</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
